import { render } from "./product-quality-notes.vue?vue&type=template&id=9003c3ae"
import script from "./product-quality-notes.vue?vue&type=script&lang=js"
export * from "./product-quality-notes.vue?vue&type=script&lang=js"

import "./product-quality-notes.vue?vue&type=style&index=0&id=9003c3ae&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__